import { render, staticRenderFns } from "./ModulesDatatable.vue?vue&type=template&id=01c8aa8e"
import script from "./ModulesDatatable.vue?vue&type=script&lang=js"
export * from "./ModulesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports